var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"application-supplement-form"},[_c('page-reg-link',{attrs:{"supplement-mode":"","supplement-data":_vm.applicationData},on:{"supplement-submitted":function($event){return _vm.$emit('submitted')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }